module.exports = __webpack_public_path__ + "static/img/app-rifeng.59f00df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app-rifeng.png
// module id = qyOT
// module chunks = 122